import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import type { FC } from 'react';

import logo from '../../logo.png';
import {
  useOrganization,
  useOrganizationSettings,
} from '../OrganizationProvider';

const displayName = 'Welcome';

const useStyles = makeStyles(
  (theme) => ({
    card: {
      backgroundColor: 'transparent',

      [theme.breakpoints.up('md')]: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[2],
        margin: 'auto',
        maxWidth: theme.spacing(48),
        minHeight: 'auto',
      },
    },

    header: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',

      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(3),
      },
    },

    logo: {
      marginRight: theme.spacing(2),
    },

    main: {
      minHeight: '100vh',
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(2),

      [theme.breakpoints.up('md')]: {
        height: 'auto',
        paddingBottom: theme.spacing(12),
        paddingTop: theme.spacing(12),
      },
    },
  }),
  { name: displayName },
);

const Welcome: FC = ({ children }) => {
  const { name } = useOrganization();
  const { logoUrl } = useOrganizationSettings();

  const classes = useStyles();

  return (
    <main className={classes.main} data-test-route="login">
      <Typography className={classes.header} component="header" variant="h4">
        <img
          alt={`${name} logo`}
          className={classes.logo}
          height={40}
          src={logoUrl || logo}
          width={40}
        />
        {name}
      </Typography>
      <Card className={classes.card} elevation={0} square>
        <CardContent>{children}</CardContent>
      </Card>
    </main>
  );
};

Welcome.propTypes = {
  children: PropTypes.node.isRequired,
};

Welcome.displayName = displayName;

export default Welcome;
